import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'user-navigation',
  templateUrl: './user-navigation.component.html',
  styleUrls: ['./user-navigation.component.scss']
})
export class UserNavigationComponent implements OnInit {

  user: any;
  mobileNavText: string;
  seriesId: number;
  moduleId: number;
  hasModuleQuiz: any;
  hasModuleSummary: boolean;

  constructor() { }

  ngOnInit(): void { }

}
